import styled from "styled-components/macro";

export const Button = styled.button``;
